/**
 * Leave the app for another address, replacing this entry in the history.
 *
 * Used where the destination is outside the router's world — the backend's
 * verify endpoint, or the staff console — so a router navigation would not
 * reach it. Replacing rather than pushing keeps the screen being left off the
 * back button: it is a waypoint, and returning to it only repeats it.
 */
export function leaveTo(url: string): void {
  window.location.replace(url);
}
